import { HashRouter, Routes, Route } from "react-router-dom";
import Auth from "./auth";
import DashboardRedirect from "./dashboard-redirect";
import Public from "./public";
import RecorderWindow from "./recorder";

export default function App() {
    return <DashboardRedirect>
        <HashRouter>
            <Routes>
                <Route path="/public/*" element={<Public />} />
                <Route path="/recorder" element={<RecorderWindow />} />
                <Route path="*" element={<Auth />} />
            </Routes>
        </HashRouter>
    </DashboardRedirect>;
}
